import React from 'react';
import { useTheme } from 'styled-components';
import { LINKS } from 'shared/links';
import { useTranslation } from 'react-i18next';
import usePageName from 'hooks/usePageName';
import { FlagKey } from 'api/types';
import useFeatureFlags from 'hooks/useFeatureFlags';
import { getDashboardRedirectPath } from 'modules/auth/Auth.utils';
import useUser from 'hooks/useUser';
import {
  CopyRightText,
  DividerStyled,
  FooterStyled,
  MenuLink,
  MenuWrapper,
  StoreButtons,
} from './Footer.styles';
import { AppStoreIconLarge } from '../icons/AppStoreIconLarge';
import { GooglePlayIconLarge } from '../icons/GooglePlayIconLarge';
import { EverBrightLogo } from '../icons/EverBrightLogo';

export function Footer() {
  const theme = useTheme();
  const { t } = useTranslation();

  const { currentPage } = usePageName();
  const {
    flags: { [FlagKey.onboardingRefresh]: onboardingRefresh },
  } = useFeatureFlags();

  const { userResult, selectedAgreement } = useUser();

  const { hasDashboardAccess } = getDashboardRedirectPath(
    userResult?.user || undefined,
    selectedAgreement,
    onboardingRefresh,
  );

  return (
    <>
      <DividerStyled />
      <FooterStyled>
        {currentPage === 'AUTH' && <EverBrightLogo />}
        <MenuWrapper>
          {LINKS.FOOTER_MENU_OPTIONS.map(({ text, link }) => (
            <MenuLink key={text} href={link} target="_blank" rel="noreferrer">
              {text}
            </MenuLink>
          ))}
        </MenuWrapper>

        <StoreButtons>
          <a
            href={LINKS.MOBILE_APP_STOREFRONTS.apple}
            target="_blank"
            rel="noreferrer"
            aria-label="apple store icon"
          >
            <AppStoreIconLarge color={theme.colors.iconIconSecondaryGrey90} />
          </a>
          <a
            href={LINKS.MOBILE_APP_STOREFRONTS.google}
            target="_blank"
            rel="noreferrer"
            aria-label="google play store icon"
          >
            <GooglePlayIconLarge color={theme.colors.iconIconSecondaryGrey90} />
          </a>
        </StoreButtons>
      </FooterStyled>
      <CopyRightText as="p" $hasPadding={hasDashboardAccess}>
        {t('copyright', { year: new Date().getFullYear() })}
      </CopyRightText>
    </>
  );
}

export default Footer;
